// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App' // This is your pre-compiled Single-File Component
import router from './router'

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

// import vmodal from 'vue-js-modal';
// Vue.use(vmodal);

import 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/vendors/bootstrap-select/dist/js/bootstrap-select.min.js';

//datePicker
import datePicker from 'vue-bootstrap-datetimepicker';
import './../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
Vue.use(datePicker);

//Select
import '../src/assets/vendors/bootstrap-select/dist/js/bootstrap-select.min'
import '../src/assets/vendors/bootstrap-select/dist/css/bootstrap-select.min.css'

import swal from './../node_modules/sweetalert2/dist/sweetalert2.min.css'
import './../node_modules/animate.css/animate.min.css'
//import './../node_modules/jquery.nicescroll/dist/jquery.nicescroll.min.js'

//Fonts
import './../node_modules/roboto-fontface/css/roboto/roboto-fontface.css'
import './../node_modules/material-design-iconic-font/dist/css/material-design-iconic-font.min.css'

//Custom Style
import '../src/assets/scss/my-listview/my-listview.scss'
import '../src/assets/scss/my-form/my-form.scss'
import '../src/assets/css/app-core.css'
import '../src/assets/css/app-ecart.css'

//JS
import './assets/js/app-core.js'

Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App) // For Vue 2: `h` is the createElement function
})